import { render, staticRenderFns } from "./backup.vue?vue&type=template&id=8f2568ae&scoped=true&"
import script from "./backup.vue?vue&type=script&lang=js&"
export * from "./backup.vue?vue&type=script&lang=js&"
import style0 from "./backup.vue?vue&type=style&index=0&id=8f2568ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2568ae",
  null
  
)

export default component.exports